import React, {createRef, useEffect, useState} from 'react';
import './App.css';
import logo from './logo_dark.png';
import {ExteriorPanorama, InteriorPanorama, PanoramaProject} from '360Viewer';

import screenfull from 'screenfull';
import styled from 'styled-components';

function App() {

  const interiorPanoramaRef = createRef<InteriorPanorama>();
  const exteriorPanoramaRef = createRef<ExteriorPanorama>();

  const DownIcon = './assets/arrow_downward_black_24dp.svg';
  const UpIcon = './assets/arrow_upward_black_24dp.svg';
  const LeftIcon = './assets/rotate_left_black_24dp.svg';
  const RightIcon = './assets/rotate_right_black_24dp.svg';
  const AutoRotateIcon = './assets/360_black_24dp.svg';
  const StopIcon = './assets/stop_black_24dp.svg';
  const FullscreenIcon = './assets/open_in_full_black_24dp.svg';
  const CloseFullscreenIcon = './assets/close_fullscreen_black_24dp.svg';
  const ShowHotspotsIcon = './assets/visibility_black_24dp.svg';
  const HideHotspotsIcon = './assets/visibility_off_black_24dp.svg';
  const ZoomInIcon = './assets/zoom_in_black_24dp.svg';
  const ZoomOutIcon = './assets/zoom_out_black_24dp.svg';
  const Number1 = './assets/number_1.svg';
  const Number2 = './assets/number_2.svg';
  const Number3 = './assets/number_3.svg';
  const Number4 = './assets/number_4.svg';
  const Number5 = './assets/number_5.svg';
  const NumberSelected1 = './assets/number_selected_1.svg';
  const NumberSelected2 = './assets/number_selected_2.svg';
  const NumberSelected3 = './assets/number_selected_3.svg';
  const NumberSelected4 = './assets/number_selected_4.svg';
  const NumberSelected5 = './assets/number_selected_5.svg';

  const numbers = [Number1, Number2, Number3, Number4, Number5];
  const selectedNumbers = [NumberSelected1, NumberSelected2, NumberSelected3, NumberSelected4, NumberSelected5];

  enum ViewState {
    loading,
    interior,
    exterior,
  }

  const [viewState, setViewState] = useState<ViewState>(ViewState.loading);
  const [hasInterior, setHasInterior] = useState<boolean>(false);
  const [hasExterior, setHasExterior] = useState<boolean>(false);

  const [isLoading, setLoading] = useState<boolean>(true);

  const [autorotating, setAutorotating] = useState<boolean>(false);
  const [showHotspots, setShowHotspots] = useState<boolean>(false);
  const [isFullscreen, setFullscreen] = useState<boolean>(false);

  const [panoramaIndex, setPanoramaIndex] = useState<number>(0);
  const [initialFrame, setInitialFrame] = useState<number>(0);

  const [project, setProject] = useState<PanoramaProject | null>();
  const [projectLocation, setProjectLocation] = useState<string>('');

  useEffect(() => {
    const fetcher = async (): Promise<void> => {
      // @ts-ignore
      let params = (new URL(document.location)).searchParams;
      const projectLocation = params.get('project');
      if (!!projectLocation) {
        setProjectLocation(projectLocation);
      }
      const response = await fetch(`${projectLocation}/manifest.json`);
      console.log("RESPONSE", response);
      const json = await response.json();
      setProject(json);
      console.log(json, json?.interiorPanoramas);
      if (!!json && !!json.interiorPanoramas && json.interiorPanoramas.length > 0) {
        setHasInterior(true)
        if (!!json.initialInteriorPanorama) {
          setPanoramaIndex(json.initialInteriorPanorama);
        } else {
          setPanoramaIndex(0);
        }
        setViewState(ViewState.interior);
      }
      if (!!json && !!json.exteriorPanoramas && json.exteriorPanoramas.length > 0) {
        setHasExterior(true);
        if (!!json.initialExteriorPanorama) {
          setPanoramaIndex(json.initialExteriorPanorama);
        } else {
          setPanoramaIndex(0);
        }
        setViewState(ViewState.exterior);
      }
    }
    fetcher().then();
  }, [setProjectLocation, setProject]);

  // console.log(exteriorPanoramaRef.current?.isFullscreen());

  return (
    <div className="App">
      {(!!project && hasInterior && hasExterior) && (
        <div id={'segmented_control'}>
          <SegmentButton className={'segment_button'} title={'Exterior Panorama'} selected={viewState === ViewState.exterior} onClick={() => {
            setPanoramaIndex(0);
            setViewState(ViewState.exterior);
          }}>Exterior
            Panorama
          </SegmentButton>
          <SegmentButton className={'segment_button'} title={'Interior Panorama'} selected={viewState === ViewState.interior} onClick={() => {
            setPanoramaIndex(0);
            setViewState(ViewState.interior);
          }}>Interior Panorama
          </SegmentButton>
        </div>
      )}


      {viewState === ViewState.interior && !!project &&
      <InteriorPanorama project={project}
                        panoramaIndex={(panoramaIndex < project.interiorPanoramas.length ? panoramaIndex : 0)}
                        projectLocation={projectLocation}
                        ref={interiorPanoramaRef}
                        initialPitch={-10}
                        autorotateOnStart={false}
                        onHotspotSelected={(hotspot, _event) => {
                          alert(`${hotspot.name} was selected`);
                        }}
                        hotspotsInitialyShown={false}
      >
        <div id={'interior_buttons'}>
          {project.interiorPanoramas.length > 1 &&
          project.interiorPanoramas.map((p, i) => {
            return (<button className={'pano_button'} key={i} title={`${i + 1}`} onClick={() => {
              setPanoramaIndex(i);
              interiorPanoramaRef.current?.forceUpdate();
            }}>{i < 5 ? <img src={panoramaIndex === i ? selectedNumbers[i] : numbers[i]} alt={`panorama ${i}`}/> : `${i + 1}`}</button>)
          })
          }
          <button className={'pano_button'} title={'Start autorotate'} onClick={() => {
            interiorPanoramaRef.current?.autorotate(!autorotating, 100);
            setAutorotating(!autorotating);
          }}><img src={autorotating ? StopIcon : AutoRotateIcon} alt={'Autorotate'}/></button>
          <button className={'pano_button'} title={'Left'} onClick={() => {
            interiorPanoramaRef.current?.moveLeft(10, 500);
          }}><img src={RightIcon} alt={'Left'}/></button>
          <button className={'pano_button'} title={'Right'} onClick={() => {
            interiorPanoramaRef.current?.moveRight(10, 500);
          }}><img src={LeftIcon} alt={'Right'}/></button>
          <button className={'pano_button'} title={'Up'} onClick={() => {
            interiorPanoramaRef.current?.moveUp(10, 500);
          }}><img src={UpIcon} alt={'Up'}/></button>
          <button className={'pano_button'} title={'Down'} onClick={() => {
            interiorPanoramaRef.current?.moveDown(10, 500);
          }}><img src={DownIcon} alt={'Down'}/></button>
          <button className={'pano_button'} title={'Zoom in'} onClick={() => {
            interiorPanoramaRef.current?.zoomIn(5, 500);
          }}><img src={ZoomInIcon} alt={'Zoom in'}/></button>
          <button className={'pano_button'} title={'Zoom out'} onClick={() => {
            interiorPanoramaRef.current?.zoomOut(5, 500);
          }}><img src={ZoomOutIcon} alt={'Zoom out'}/></button>
          {screenfull.isEnabled &&
          <button className={'pano_button'} title={'Fullscreen'} onClick={() => {
            if (isFullscreen) {
              interiorPanoramaRef.current?.exitFullScreen();
              setFullscreen(false);
            } else {
              interiorPanoramaRef.current?.enterFullScreen();
              setFullscreen(true)
            }

          }}><img src={isFullscreen ? CloseFullscreenIcon : FullscreenIcon} alt={'Fullscreen'}/></button>
          }
          {project.interiorPanoramas[panoramaIndex].detailPhotos && project.interiorPanoramas[panoramaIndex].detailPhotos.length > 0 &&
          <button className={'pano_button'} title={'Show hotspots'} onClick={() => {
            if (showHotspots) {
              interiorPanoramaRef.current?.hideHotspots();
              setShowHotspots(false);
            } else {
              interiorPanoramaRef.current?.showHotspots();
              setShowHotspots(true);
            }
          }}><img src={showHotspots ? HideHotspotsIcon : ShowHotspotsIcon} alt={'Hotspots'}/></button>
          }
        </div>
      </InteriorPanorama>
      }
      {viewState === ViewState.exterior &&
      !!project &&
      <ExteriorPanorama project={project}
                        panoramaIndex={(panoramaIndex < project.exteriorPanoramas.length ? panoramaIndex : 0)}
                        projectLocation={projectLocation}
                        useSprite={false}
                        ref={exteriorPanoramaRef}
                        initialFrame={initialFrame}
                        autorotateOnStart={false}
                        onHotspotSelected={(hotspot, _event) => {
                          alert(`${hotspot.name} was selected`);
                        }}
                        onPanoramaChanged={(index: number) => {
                          setPanoramaIndex(index);
                        }}
                        hotspotsInitialyShown={true}
                        width={900}
                        height={600}
                        hasInterior={hasInterior}
                        onLoadFinished={(finished) => setLoading(!finished)}
      >
        {!isLoading &&
          <div id={'exterior_buttons'}>
            {!!project && project.exteriorPanoramas.length > 1 &&
              project.exteriorPanoramas.map((p, i) => {
                return (<button className={'pano_button'} key={i} title={`${i + 1}`} onClick={() => {
                  const currentFrame = exteriorPanoramaRef.current?.getCurrentFrame() ?? 0;
                  setInitialFrame(currentFrame);
                  setPanoramaIndex(i);
                  exteriorPanoramaRef.current?.switchPanorama(i, currentFrame);
                  // exteriorPanoramaRef.current?.forceUpdate();
                }}>{i < 5 ? <img src={panoramaIndex === i ? selectedNumbers[i] : numbers[i]}/> : `${i + 1}`}</button>)
              })
            }
            <button className={'pano_button'} title={'Start autorotate'} onClick={() => {
              if (autorotating) {
                exteriorPanoramaRef.current?.stopAutorotate();
              } else {
                exteriorPanoramaRef.current?.startAutorotate(4800, 60000);
              }
              setAutorotating(!autorotating);
            }}><img src={autorotating ? StopIcon : AutoRotateIcon} alt={'Autorotate'}/></button>
            <button className={'pano_button'} title={'Left'} onClick={() => {
              exteriorPanoramaRef.current?.moveLeft(360 / project!.exteriorPanoramas[panoramaIndex].photos.length, 500);
            }}><img src={RightIcon} alt={'Left'}/></button>
            <button className={'pano_button'} title={'Right'} onClick={() => {
              exteriorPanoramaRef.current?.moveRight(360 / project!.exteriorPanoramas[panoramaIndex].photos.length, 500);
            }}><img src={LeftIcon} alt={'Right'}/></button>
            {screenfull.isEnabled &&
              <button className={'pano_button'} title={'Fullscreen'} onClick={() => {
                if (isFullscreen) {
                  exteriorPanoramaRef.current?.exitFullScreen();
                  setFullscreen(false);
                } else {
                  exteriorPanoramaRef.current?.enterFullScreen();
                  setFullscreen(true);
                }

              }}><img src={isFullscreen ? CloseFullscreenIcon : FullscreenIcon} alt={'Fullscreen'}/></button>
            }
            {!!project && !!project.exteriorPanoramas[panoramaIndex].detailPhotos && project.exteriorPanoramas[panoramaIndex].detailPhotos.length > 0 &&
              <button className={'pano_button'} title={'Show hotspots'} onClick={() => {
                if (showHotspots) {
                  exteriorPanoramaRef.current?.hideHotspots();
                  setShowHotspots(false);
                } else {
                  exteriorPanoramaRef.current?.showHotspots();
                  setShowHotspots(true);
                }
              }}><img src={showHotspots ? HideHotspotsIcon : ShowHotspotsIcon} alt={'Hotspots'}/></button>
            }
          </div>
        }
      </ExteriorPanorama>
      }
    </div>
  );
}

const SegmentButton = styled.button<any>((props: any) => ({
  color: 'var(--segmentButtonTxtClr)',
  backgroundColor: props.selected ? 'var(--segmentButtonActiveBgc)' : 'var(--segmentButtonInactiveBgc)',
}));

export default App;
